import { config, handleResponse } from '../../_helpers';

export const truckingService = {
    loadTrucking,
    getTrucking,
    createTrucking,
    updateTrucking,
    deleteTrucking,
    activation,
    getAuthorizedTrucking,
    getTruckingbyBranch,
    getTruckingForTallySheet,
    TruckingForATW,
    hustlingTrucker,
    truckingForCtsreports,
    TruckingData,
};

function TruckingData() {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Truckings`, requestOptions).then(handleResponse);
}

function truckingForCtsreports(search) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(search),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
      return fetch(`${config.apiUrl}/Truckings/truckingForCtsreports`, requestOptions).then(handleResponse);
}

function loadTrucking(skip, take, filter, search) {
    const requestOptions = {
        method: 'GET'
    };
    if (search) {
        return fetch(`${config.apiUrl}/Truckings/load?skip=${skip}&take=${take}&filter=${filter}&search=${search}`, requestOptions).then(handleResponse);
    } else {
        return fetch(`${config.apiUrl}/Truckings/load?skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    }
}
function getTrucking(code) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Truckings/getTrucking/${code}`, requestOptions).then(handleResponse);
}
function createTrucking(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/Truckings/createTrucking`, requestOptions).then(handleResponse);
      return fetch(`${config.apiUrl}/Truckings/createTruckingWithBranches`, requestOptions).then(handleResponse);
}
function updateTrucking(payload, code) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/Truckings/update/${code}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/Truckings/updateTruckingWithBranch/${code}`, requestOptions).then(handleResponse);
}
function deleteTrucking(code) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(code),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Truckings/delete`, requestOptions).then(handleResponse);
}
function activation(code, isActive) {
    const requestOptions = {
        method: 'PUT'
    };
    return fetch(`${config.apiUrl}/Truckings/isActived?id=${code}&isActivated=${isActive}`, requestOptions).then(handleResponse);
}
function getAuthorizedTrucking() {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Truckings/getAuthorizedTrucking`, requestOptions).then(handleResponse);
}
function getTruckingbyBranch(branch, isHauling) {
    const requestOptions = {
        method: 'GET'
    };
    // return fetch(`${config.apiUrl}/Truckings/getTruckingbyBranch?branch=${branch}&isHauling=${isHauling}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/Truckings/getTruckingbyMultipleBranch?branch=${branch}&isHauling=${isHauling}`, requestOptions).then(handleResponse);
}
function getTruckingForTallySheet(branch, skip, take, search) {
    const requestOptions = {
        method: 'GET'
    };
    // if (search) {
    //     return fetch(`${config.apiUrl}/Truckings/getTruckingForTallySheet?branch=${branch}&skip=${skip}&take=${take}&search=${search}`, requestOptions).then(handleResponse);
    // } else {
    //     return fetch(`${config.apiUrl}/Truckings/getTruckingForTallySheet?branch=${branch}&skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    // }
    if (search) {
        return fetch(`${config.apiUrl}/Truckings/getTruckingForTallySheetMultipleBranch?branch=${branch}&skip=${skip}&take=${take}&search=${search}`, requestOptions).then(handleResponse);
    } else {
        return fetch(`${config.apiUrl}/Truckings/getTruckingForTallySheetMultipleBranch?branch=${branch}&skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    }
}
function TruckingForATW(branch) {
    const requestOptions = {
        method: 'GET'
    };
    // return fetch(`${config.apiUrl}/Truckings/TruckingForATW?branch=${branch}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/Truckings/TruckingForATWMutlipleBranch?branch=${branch}`, requestOptions).then(handleResponse);
}
function hustlingTrucker(branch) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Truckings/hustlingTrucker/${branch}`, requestOptions).then(handleResponse);
}